export function formatBytesLabel(bytes) {
  const n = Number(bytes);
  if (!Number.isFinite(n) || n <= 0) return "0 bytes";
  const MB = 1024 * 1024;
  const KB = 1024;
  if (n >= MB) {
    const mb = n / MB;
    return Number.isInteger(mb) ? `${mb}MB` : `${mb.toFixed(1)}MB`;
  }
  if (n >= KB) {
    const kb = Math.round(n / KB);
    return `${kb}KB`;
  }
  return `${n} bytes`;
}
